import "./header.scss";

import React, { useState } from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import classNames from "classnames";

import TopBar from "../TopBar/TopBar";
import SearchBar from "../SearchBar/SearchBar";

const Header = ({ data, pages }) => {
	const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [submenuOpened, setSubmenuOpened] = useState("");

	const showSearchBar = () => {
		setIsSearchBarOpen(true);
	};
	const closeSearchBar = () => {
		setIsSearchBarOpen(false);
	};

	const options = data.nodes[0].acfOptionsOpcje.optionsPage;

	return (
		<>
			<SearchBar
				opened={isSearchBarOpen}
				onCloseClick={closeSearchBar}
				data={data}
				pages={pages}
			/>
			<header className="header container">
				<TopBar onSearchClick={showSearchBar} />
				<div className="header__main-bar">
					<Link to="/" className="header__logo-link">
						<img
							src={
								require("assets/images/elcamp-logo.svg").default
							}
							alt="Elcamp.pl"
							className="header__logo"
						/>
					</Link>
					<nav
						className={classNames(`header__navigation`, {
							[`header__navigation--open`]: isMenuOpen,
						})}
					>
						<div
							className="header__nav-item"
							onClick={(e) =>
								submenuOpened === "vehicles"
									? setSubmenuOpened("")
									: setSubmenuOpened("vehicles")
							}
							aria-hidden="true"
						>
							<div className="header__nav-link">
								Pojazdy kempingowe
							</div>
							<div
								className={classNames(
									`header__hidden-menu`,
									`header__hidden-menu--cars`,
									{
										[`header__hidden-menu--active`]:
											submenuOpened === "vehicles",
									}
								)}
							>
								<div
									className="header__hidden-img-box"
									style={{
										backgroundImage: `url(${options.promotedOfferImg?.sourceUrl})`,
									}}
								>
									<div className="header__box-text">
										{options.promotedOfferTitle}
									</div>
									<div className="header__box-text header__box-text--small">
										{options.promotedOfferDesc}
									</div>
									<Link
										to={options.promotedOfferLink}
										className="btn header__box-button"
									>
										Sprawdź
									</Link>
								</div>
								<div className="header__hidden-menu-holder">
									<Link
										to="/nowe-kampery-i-nowe-przyczepy-campingowe/"
										className="header__hidden-nav-link"
									>
										Nowe kampery i przyczepy
									</Link>
									<Link
										to="/pojazdy-dostepne-od-reki/?used=true"
										className="header__hidden-nav-link"
									>
										Używane kampery i przyczepy
									</Link>
									<Link
										to="/odkup-pojazdow"
										className="header__hidden-nav-link"
									>
										Odkup pojazdów
									</Link>
									<Link
										to="/pojazdy-dostepne-od-reki/"
										className="header__hidden-nav-link header__hidden-nav-link--red-button"
									>
										Pojazdy dostępne od ręki{" "}
										<span>&#8250;</span>
									</Link>
								</div>
							</div>
						</div>
						<div
							className="header__nav-item"
							onClick={(e) =>
								submenuOpened === "services"
									? setSubmenuOpened("")
									: setSubmenuOpened("services")
							}
							aria-hidden="true"
						>
							<div className="header__nav-link">
								Serwis, części i akcesoria
							</div>
							<div
								className={classNames(
									`header__hidden-menu`,
									`header__hidden-menu--service`,
									{
										[`header__hidden-menu--active`]:
											submenuOpened === "services",
									}
								)}
							>
								<Link
									to="/serwis"
									className="header__hidden-nav-link"
								>
									Serwis
								</Link>
								<Link
									to="/serwis#serwis-8"
									className="header__hidden-nav-link"
								>
									Oryginalne części zamienne
								</Link>
								<Link
									to="/zawieszenia"
									className="header__hidden-nav-link"
								>
									Zawieszenia
								</Link>
								<Link
									to="/termika-i-oswietlenie"
									className="header__hidden-nav-link"
								>
									Termika i oświetlenie
								</Link>
								<Link
									to="/sklep-i-akcesoria"
									className="header__hidden-nav-link"
								>
									Sklep i akcesoria
								</Link>
							</div>
						</div>
						{/* <div className="header__nav-item" aria-hidden="true">
							<Link to="/wynajem" className="header__nav-link">
								Wynajem
							</Link>
						</div> */}
						<div
							className="header__nav-item"
							onClick={(e) =>
								submenuOpened === "news"
									? setSubmenuOpened("")
									: setSubmenuOpened("news")
							}
							aria-hidden="true"
						>
							<div className="header__nav-link">Aktualności</div>
							<div
								className={classNames(
									`header__hidden-menu`,
									`header__hidden-menu--news`,
									{
										[`header__hidden-menu--active`]:
											submenuOpened === "news",
									}
								)}
							>
								<Link
									to="/aktualnosci#aktualnosci"
									className="header__hidden-nav-link"
								>
									Aktualności
								</Link>
								<Link
									to="/aktualnosci#targi-i-imprezy"
									className="header__hidden-nav-link"
								>
									Targi i imprezy
								</Link>
								<Link
									to="/aktualnosci#zloty-karawaningowe"
									className="header__hidden-nav-link"
								>
									Zloty
								</Link>
								<Link
									to="/aktualnosci"
									className="header__hidden-nav-link"
								>
									#ElCamperos
								</Link>
								<a
									href="https://www.facebook.com/GrupaElcamp/"
									target="_blank"
									rel="noreferrer nofollow"
									className="header__hidden-nav-link"
								>
									Facebook
								</a>
								<a
									href="https://www.instagram.com/grupa_elcamp/"
									target="_blank"
									rel="noreferrer nofollow"
									className="header__hidden-nav-link"
								>
									Instagram
								</a>
								<a
									href="https://www.youtube.com/channel/UC5xNMylmVKGlcotQYHxAmfw"
									target="_blank"
									rel="noreferrer nofollow"
									className="header__hidden-nav-link"
								>
									Youtube
								</a>
							</div>
						</div>
						<div
							className="header__nav-item"
							onClick={(e) =>
								submenuOpened === "contact"
									? setSubmenuOpened("")
									: setSubmenuOpened("contact")
							}
							aria-hidden="true"
						>
							<div className="header__nav-link">Kontakt</div>
							<div
								className={classNames(
									`header__hidden-menu`,
									`header__hidden-menu--contact`,
									{
										[`header__hidden-menu--active`]:
											submenuOpened === "contact",
									}
								)}
							>
								<Link
									to="/kontakt#dany-firmy"
									className="header__hidden-nav-link"
								>
									Dane firmy i lokalizacja
								</Link>
								<Link
									to="/kontakt#formularz"
									className="header__hidden-nav-link"
								>
									Formularz kontaktowy
								</Link>
								<Link
									to="/kontakt"
									className="header__hidden-nav-link"
								>
									Pliki do pobrania
								</Link>
								<Link
									to="/kontakt/#dzialy-firmy"
									className="header__hidden-nav-link"
								>
									Kontakt z działami firmy
								</Link>
							</div>
						</div>
						<div className="header__nav-item">
							<a
								href="https://sklep.elcamp.pl/"
								target="_blank"
								rel="noreferrer nofollow"
								className="header__nav-link header__nav-link--shop"
							>
								Sklep
							</a>
						</div>
					</nav>
					<button
						type="button"
						aria-label="Open Menu"
						className={`hamburger hamburger--squeeze ${
							isMenuOpen ? "is-active" : ""
						}`}
						onClick={(e) => setIsMenuOpen(!isMenuOpen)}
					>
						{Array(4)
							.fill(null)
							?.map((item, index) => (
								<span key={index} />
							))}
					</button>
				</div>
			</header>
		</>
	);
};

export default () => (
	<StaticQuery
		query={graphql`
			{
				data: allWp {
					nodes {
						acfOptionsOpcje {
							optionsPage {
								promotedOfferLink
								promotedOfferTitle
								promotedOfferDesc
								promotedOfferImg {
									sourceUrl
								}
								promotedProductTitle
								promotedProductLink
								promotedProductImage {
									sourceUrl
								}
								promotedButtonColor
								promotedButtonName
							}
						}
					}
				}
				pages: allWpPage {
					edges {
						node {
							id
							title
						}
					}
				}
			}
		`}
		render={(data) => <Header {...data} />}
	/>
);
